import React, { useState, useRef } from "react";
import Dialog from "../../base/ui/components/web/Dialog";
import { translate } from "../../base/i18n/functions";
import { useTranslation } from "react-i18next";
import { hideDialog } from "../../base/dialog/actions";
import { connect } from "react-redux";

import {
    Box,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from "@mui/material";
import { sendrequestPay } from "../actions";
import { useDispatch } from "react-redux";
import { getParticipantById } from "../../base/participants/functions";
import {} from "@mui/material";
import { openChat, sendSignatureMessage } from "../../chat/actions.web";

const AskingToPayDialog = ({ state, participantID }) => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState({
        url: "",
        paymentAmount: "",
    });

    const urlRef = useRef("");
    const paymentAmountRef = useRef();
    // const paymentTypeRef = useRef("AED");
    const [paymentType, setPaymentType] = useState("AED");
    const participantObject = getParticipantById(state, participantID);

    const dispatch = useDispatch();

    const validateForm = () => {
        const url = urlRef.current;
        const paymentAmount = paymentAmountRef.current;

        const errors = {
            url: "",
            paymentAmount: "",
        };
        if (url.trim() === "") {
            errors.url = t("dialog.payRequiredURL");
        } else if (!isValidUrl(url)) {
            errors.url = t("dialog.payInvaildURL");
        }

        if (isNaN(paymentAmount) || paymentAmount <= 0) {
            errors.paymentAmount = t("dialog.payInvaildAmount");
        }

        return errors;
    };

    const isValidUrl = (url) => {
        const urlPattern = /^(http|https):\/\/[^ "]+$/;
        return urlPattern.test(url.trim());
    };

    const hasErrors = (errors) => {
        return Object.values(errors).some((error) => error !== "");
    };

    const handleSubmit = () => {
        const formErrors = validateForm();
        if (hasErrors(formErrors)) {
            setErrors(formErrors);
        } else {
            dispatch(sendrequestPay(participantID, urlRef));
            const message = `Customer: ${participantObject.name} 
------------------------------------
Amount AED: ${paymentAmountRef.current}
------------------------------------
Payment link:${urlRef.current}`;
            // Amount AED: ${paymentAmountRef.current} ${paymentType}`;

            dispatch(openChat(participantObject));
            dispatch(sendSignatureMessage(participantID, message));
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSubmit();
            // isValidUrl(urlRef.current) ? dispatch(hideDialog()) : null
            isValidUrl(urlRef.current) &&
            !isNaN(paymentAmountRef.current) &&
            paymentAmountRef.current > 0
                ? dispatch(hideDialog())
                : null;
        }
    };

    const handleChangeUrl = (event) => {
        const { value } = event.target;
        urlRef.current = value;
        setErrors({ ...errors, url: "" });
    };

    const handleChangePaymentAmount = (event) => {
        const { value } = event.target;
        paymentAmountRef.current = value;
        setErrors({ ...errors, paymentAmount: "" });
    };
    const handleChangePaymentType = (event) => {
        const { value } = event.target;
        setPaymentType(value);
        console.log("paymentType", paymentType);
    };
    const onClose = () => {
        return true;
    };

    return (
        <Dialog
            ok={{ translationKey: "dialog.confirm" }}
            onCancel={onClose}
            onSubmit={handleSubmit}
            disableAutoHideOnSubmit={
                isValidUrl(urlRef.current) &&
                !isNaN(paymentAmountRef.current) &&
                paymentAmountRef.current > 0
                    ? false
                    : true
            }
            titleKey={t("dialog.payAskingTitle")}
        >
            <Box
                sx={{
                    display: "grid",
                    gap: "10px",
                    padding: "8px",
                    // height: '300px',
                    "& label": {
                        color: "#fff",
                    },
                    "& input": {
                        color: "#fff",
                        borderBottom: "1px solid #fff",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        "& label": {
                            minWidth: "125px",
                            fontSize: "15px",
                            fontWeight: "bold",
                        },
                    }}
                >
                    <label>Customer:</label>
                    <div>{participantObject.name}</div>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        "& label": {
                            minWidth: "125px",
                            paddingTop: "15px",
                            fontSize: "15px",
                            fontWeight: "bold",
                        },
                    }}
                >
                    <label>Amount AED:</label>
                    <TextField
                        type="number"
                        variant="standard"
                        name="paymentAmount"
                        value={paymentAmountRef.current}
                        onChange={handleChangePaymentAmount}
                        error={errors.paymentAmount !== ""}
                        helperText={errors.paymentAmount}
                        sx={{
                            paddingTop: `${
                                errors.paymentAmount ? "35px" : "unset"
                            }`,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        "& label": {
                            minWidth: "125px",
                            paddingTop: "15px",
                            fontSize: "15px",
                            fontWeight: "bold",
                        },
                    }}
                >
                    <label>Payment link:</label>
                    <TextField
                        variant="standard"
                        name={t("dialog.payURL")}
                        value={urlRef.current}
                        onChange={handleChangeUrl}
                        onFocus={() => setErrors({ ...errors, url: "" })}
                        error={errors.url !== ""}
                        helperText={errors.url}
                        onKeyDown={handleKeyDown}
                        sx={{ paddingTop: `${errors.url ? "35px" : "unset"}` }}
                    />
                </Box>
            </Box>
        </Dialog>
    );
};

export function _mapStateToProps(state) {
    return {
        state: state,
    };
}
export default translate(connect(_mapStateToProps)(AskingToPayDialog));
